/**
 * Question builder page layout — follows Dashboard pattern (fluid page in AppShell `main`,
 * flex-wrap columns, 32dp gaps). Instrument workspace bleed/rail/dvh caps are not used here.
 */
export const QUESTION_BUILDER_PAGE_GAP_PX = 32

/** Page inset around workspace body — cancels AppShell `p: 3` (24px) and applies true 32dp (Figma 4398:5108). */
export const QUESTION_BUILDER_PAGE_GUTTER_PX = 32

/** Side-by-side list + editor from `lg` (Dashboard metric grid uses `lg` for desktop columns). */
export const QUESTION_BUILDER_DESKTOP_BREAKPOINT = 'lg' as const

/** Stacked mobile columns keep a usable minimum before side-by-side fill from `lg`. */
export const QUESTION_BUILDER_PANEL_STACK_MIN_HEIGHT_PX = 320
